import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EditLifemapEntryComponent } from './editLifemapEntry.component';
import { PlIconModule } from '@app/icon-library/lib/pl-icon.module';
import { ButtonModule } from '@app/components/button/button.module';
import { PlInputModule } from '@app/components/pl-input/pl-input.module';
import { ReactiveFormsModule } from '@angular/forms';
import { PlTimepickerModule } from '@app/components/pl-timepicker/pl-timepicker.module';
import { TranslateModule } from '@ngx-translate/core';
import { LifemapQuestionsModule } from '@app/components/blocks/block-lifemap/lifemapQuestions/lifemapQuestions.module';
import { CarouselModule } from '@app/components/carousel/carousel.module';
import { LifemapQuestionsValidatorDirective } from '@app/components/blocks/block-lifemap/lifemapQuestions/lifemapQuestionValidator';
import { PlDropdownModule } from '@app/components/pl-dropdown/pl-dropdown.module';

@NgModule({
  imports: [
    CommonModule,
    PlIconModule,
    ButtonModule,
    PlInputModule,
    ReactiveFormsModule,
    PlTimepickerModule,
    TranslateModule,
    LifemapQuestionsModule,
    CarouselModule,
    PlDropdownModule,
  ],
  declarations: [EditLifemapEntryComponent, LifemapQuestionsValidatorDirective],
  exports: [EditLifemapEntryComponent],
})
export class EditLifemapEntryModule {}
